import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dialog-custom__header stepfour-header" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { style: {"height":"calc(100vh - 287px)"} }
const _hoisted_5 = {
  class: "p-field d-flex mb-3 align-items-end",
  style: {"height":"36px"}
}
const _hoisted_6 = { class: "p-field-label" }
const _hoisted_7 = {
  key: 0,
  class: "p-field-label error-mismatch fs-15 ml-auto mr-2"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = { class: "label-error" }
const _hoisted_10 = {
  key: 0,
  class: "list-blocks"
}
const _hoisted_11 = {
  class: "d-flex",
  style: {"align-items":"start"}
}
const _hoisted_12 = { class: "p-field mr-3" }
const _hoisted_13 = { class: "p-field-label bigger-label" }
const _hoisted_14 = { class: "d-flex flex-column" }
const _hoisted_15 = { class: "p-field" }
const _hoisted_16 = { class: "p-field-label bigger-label" }
const _hoisted_17 = {
  key: 0,
  class: "list-blocks-secondary p-0"
}
const _hoisted_18 = { class: "form-custom d-flex" }
const _hoisted_19 = { class: "p-field mr-4" }
const _hoisted_20 = { class: "p-field-label bigger-label" }
const _hoisted_21 = { class: "d-flex flex-column" }
const _hoisted_22 = { class: "p-field" }
const _hoisted_23 = { class: "p-field-label bigger-label" }
const _hoisted_24 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NumberButtons = _resolveComponent("NumberButtons")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_CardContainer = _resolveComponent("CardContainer")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("SetupRisersTitle", { buildingName: _ctx.buildingName })), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        (!_ctx.changingBuilding)
          ? (_openBlock(), _createBlock(_component_ElScrollbar, {
              key: 0,
              class: "dialog-scroll"
            }, {
              default: _withCtx(() => [
                _createVNode("div", null, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("AppResourceEP.SetupBuilding")), 1),
                    (!_ctx.allApartmentsAssigned)
                      ? (_openBlock(), _createBlock("span", _hoisted_7, [
                          _createVNode("label", null, _toDisplayString(_ctx.mismatchedApartmentsErrorText[0]), 1),
                          _hoisted_8,
                          _createVNode("label", _hoisted_9, _toDisplayString(_ctx.mismatchedApartmentsErrorText[1]), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_CardContainer, {
                    titleIcon: require(`@/assets/images/entrancePlants/icon-riser.svg`),
                    title: _ctx.titleCard,
                    showActionButton: false
                  }, {
                    actionButton: _withCtx(() => [
                      _createVNode(_component_NumberButtons, {
                        lightTheme: "",
                        minValue: 1,
                        modelValue: _ctx.risersCount,
                        onIncrement: _ctx.addRiser,
                        onDecrement: _ctx.removeRiser
                      }, null, 8, ["modelValue", "onIncrement", "onDecrement"])
                    ]),
                    default: _withCtx(() => [
                      (_ctx.currentRFAConfig)
                        ? (_openBlock(), _createBlock("ul", _hoisted_10, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentRFAConfig.risers, (riser, i) => {
                              return (_openBlock(), _createBlock("li", {
                                class: "riser-row",
                                key: i
                              }, [
                                _createVNode("form", _hoisted_11, [
                                  _createVNode("div", _hoisted_12, [
                                    _createVNode("label", _hoisted_13, _toDisplayString(_ctx.riserName(riser.index)) + ": ", 1),
                                    _createVNode("div", _hoisted_14, [
                                      _createVNode(_component_InputText, {
                                        type: "text",
                                        modelValue: riser.name,
                                        "onUpdate:modelValue": ($event: any) => (riser.name = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_15, [
                                    _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("AppResourceEP.NumberOfFloorsUpper")) + ": ", 1),
                                    _createVNode(_component_Dropdown, {
                                      options: _ctx.floorsCountValues,
                                      modelValue: riser.floors.length,
                                      onChange: (e) => _ctx.changeFloorNumber(riser, e.value)
                                    }, null, 8, ["options", "modelValue", "onChange"])
                                  ]),
                                  (riser.floors)
                                    ? (_openBlock(), _createBlock("ul", _hoisted_17, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(riser.floors, (floor, i) => {
                                          return (_openBlock(), _createBlock("li", {
                                            class: "riser-row",
                                            key: i
                                          }, [
                                            _createVNode("form", _hoisted_18, [
                                              _createVNode("div", _hoisted_19, [
                                                _createVNode("label", _hoisted_20, _toDisplayString(_ctx.floorName(floor.index)) + ": ", 1),
                                                _createVNode("div", _hoisted_21, [
                                                  _createVNode(_component_InputText, {
                                                    type: "text",
                                                    class: "w-100",
                                                    modelValue: floor.name,
                                                    "onUpdate:modelValue": ($event: any) => (floor.name = $event)
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                ])
                                              ]),
                                              _createVNode("div", _hoisted_22, [
                                                _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("AppResourceEP.NumberOfApartmentsUpper")) + ": ", 1),
                                                _createVNode(_component_Dropdown, {
                                                  options: _ctx.apartmentCountValues,
                                                  optionLabel: "label",
                                                  optionValue: "value",
                                                  modelValue: floor.numberOfApartments,
                                                  onChange: (e) => _ctx.changeApartmentNumber(floor, e.value)
                                                }, null, 8, ["options", "modelValue", "onChange"])
                                              ])
                                            ])
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["titleIcon", "title"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("footer", _hoisted_24, [
      _createVNode(_component_Button, {
        onClick: _ctx.handleBackButton,
        label: _ctx.$t('AppResource.Back'),
        class: "p-button-text mr-3"
      }, null, 8, ["onClick", "label"]),
      _createVNode(_component_Button, {
        onClick: _ctx.handleNextButton,
        label: _ctx.$t('AppResource.Continue'),
        class: "p-button-rounded p-button-raised p-button--m",
        disabled: !_ctx.allApartmentsAssigned
      }, null, 8, ["onClick", "label", "disabled"])
    ])
  ], 64))
}